module.exports = __webpack_public_path__ + "static/img/sign-3.d5d3e1a3.png";